module.exports = __webpack_public_path__ + "img/el-ic-management.45e42130.svg";